import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { PrismicColor } from "utils";

import { Box, Wrapper } from "components";

/**
 * Map the Prismic "width" Select (options: "Default", "2/3", "1/2") to the
 * image's column width within the Wrapper. The field has no full-width (1/1)
 * option, so "Default" — and anything unrecognized — is the contained 1/2.
 */
export function columnWidth(width) {
  if (width === "2/3") return 2 / 3;
  return 1 / 2;
}

export function FullWidthImage({ image, background, width }) {
  const gatsbyImage = getImage(image && image.gatsbyImageData);

  if (gatsbyImage)
    return (
      <Wrapper
        py={{ _: "layout.5", md: "layout.6" }}
        bg={PrismicColor(background)}
      >
        <Box width={{ _: 1 / 1, lg: columnWidth(width) }} mx="auto">
          <GatsbyImage image={gatsbyImage} alt={(image && image.alt) || ""} />
        </Box>
      </Wrapper>
    );
  else return null;
}
